import { render, staticRenderFns } from "./CopyrightAmendmentFormFiles.vue?vue&type=template&id=39d26214&scoped=true&"
import script from "./CopyrightAmendmentFormFiles.vue?vue&type=script&lang=js&"
export * from "./CopyrightAmendmentFormFiles.vue?vue&type=script&lang=js&"
import style0 from "./CopyrightAmendmentFormFiles.vue?vue&type=style&index=0&id=39d26214&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39d26214",
  null
  
)

export default component.exports